export const EMPTY_STATE_COLSPAN = 5;
